module.exports = __webpack_public_path__ + "img/ruStore.d51e6a85.svg";